import { CompanyBranding } from "./branding.model";

export class CompanyBrandingHelper {
  public static getAdvisorPhone(branding: CompanyBranding, advisorPhone: string): string {
    return branding?.configuration?.useIndividualAdvisorPhoneNumbers && advisorPhone ?
      advisorPhone : branding?.phone;
  }
}